import get from 'lodash/get';
import { getBreakpoint } from '../../../../utils/commonHelper';
import { addLead } from '../../../../store/actions/dataLayer';
import { showAdditionalLeadsModal } from '../../../../store/actions';
import { getCurrentBoats as bts } from '../../../../utils/language';
import { scrollTo } from '../../../../utils/scrollTo';
import * as listingHelper from '../../../../utils/listingHelper';
import { overflowContainer } from '../../../../utils';
import { syncTranslationElements } from '../../../../utils/translations/translationsSync';
import { useBdpActions } from './bdpActions';

import { setEnhancedEcommerce } from '../../../../store/actions/dataLayer';

const BROKER_SPOTLIGHT_CONTACT = 'Broker Spotlight';
export const BDP_ANCHOR = 'root-anchor';
const MAX_LEADERBOARD_ADS_RESOLUTION = 1120;

export const useBdpHandlers = (state, setState, props, context, dispatch) => {
  const { trackContactFormOpen, openCarouselModal } = useBdpActions();


  const resizeHandler = () => {
    setState({
      showLeaderboardDesktopAds: showLeaderboardDesktopAds(),
      breakpoint: getBreakpoint()
    });
  };

  const getDocHeight = () => {
    return Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
  };

  const showLeaderboardDesktopAds = () => {
    return window.innerWidth >= MAX_LEADERBOARD_ADS_RESOLUTION;
  };

  const handleResize = () => {
    const winHeight = window.innerHeight;
    const docHeight = getDocHeight();
    const trackLength = docHeight - winHeight;
    setState({ trackLength: trackLength });
  };


  const handleOpenContactModal = (event, data) => {
    let contactButtonOrigin;

    if (event?.target?.id === 'broker-spotlight-contact-button') {
      const { listing } = props;

      addLead(listing.owner.brokerSpotlightId, 'email lead', null);
      dispatch(
        setEnhancedEcommerce(
          [bts().LISTING_PREMIUM_BROKER],
          listing.owner.brokerSpotlightId
        )
      );

      contactButtonOrigin = BROKER_SPOTLIGHT_CONTACT;
    }

    setState({
      contactOrigin: contactButtonOrigin,
      showContactModal: true,
      hideSavedSearchPopup: true,
      contactModal: {
        prePopulatedText: data?.prePopulatedText || ''
      }
    });
  };


  const hideModal = () => {
    scrollTo('#root-anchor');
    setState({
      showModalCarousel: false,
      showImmersiveTourModal: false
    });
    overflowContainer(false);
  };

  const showModal = (index = 0) => {
    dispatch(openCarouselModal());
    setState({
      carouselIndex: index,
      showModalCarousel: true
    });
  };

  const openModalPostLead = (leadData) => {
    dispatch(showAdditionalLeadsModal(leadData));
  };

  const handleCloseContactModal = () => {
    setState({
      showContactModal: false,
      hideSavedSearchPopup: false
    });
  };

  const handleBoatSummaryScroll = (scrolledPastBoatSummary) => {
    setState({ scrolledPastBoatSummary });
  };

  const handleSummaryLocationLinkClicked = (componentCounter) => {
    setState({
      openLocationComponent: 'location-map',
      openLocationComponentCounter: componentCounter
    });
  };

  const handleSummaryLoansButtonclicked = (componentCounter) => {
    setState({
      openBoatLoansComponent: 'boat-loans',
      openBoatLoansComponentCounter: componentCounter
    });
  };

  const handleSummaryPaymentLinkClicked = (componentCounter) => {
    setState({
      openPaymentComponent: 'payment-calculator',
      openPaymentComponentCounter: componentCounter
    });
  };

  const toggleVideoTourModal = () => {
    setState({
      ...state,
      showVideoTourForm: !state.showVideoTourForm
    });
  };

  const toggleDealerLocatorModal = (active) => {
    setState({ ...state, showDealerLocatorModal: active });
  };

  const showModalPreQualified = (show) => {
    setState({ showModalPreQualified: show });
  };

  const getCarouselButtonTrayProps = (listing) => {
    const showLiveVideoTourButton = get(
      context,
      'supports.showLiveVideoTourButton',
      false
    );
    const carouselButtonTrayProps = {
      listing,
      productType: 'boat',
      openCarouselModal: (index) => showModal(index)
    };
    if (
      showLiveVideoTourButton &&
      listingHelper.isAvailableForLiveVideoTour(listing)
    ) {
      carouselButtonTrayProps.openVideoTourModal = () => toggleVideoTourModal();
    }

    return carouselButtonTrayProps;
  };

  const getButtonTrayProps = (listing) => {
    const showLiveVideoTourButton = get(
      context,
      'supports.showLiveVideoTourButton',
      false
    );
    const buttonTrayProps = {
      listing,
      productType: 'boat'
    };
    if (
      showLiveVideoTourButton &&
      listingHelper.isAvailableForLiveVideoTour(listing)
    ) {
      buttonTrayProps.openVideoTourModal = () => toggleVideoTourModal();
    }

    return buttonTrayProps;
  };

  const handleOpenContactForm = (e, UIEvent = {}) => {
    trackContactFormOpen();
    setState({ showContactModal: true, UIEvent });
  };

  const openImmersiveTourModal = () => {
    setState({ showImmersiveTourModal: true });
  };

  const openCarousel = (index = 0) => {
    openCarouselModal();
    setState({
      carouselIndex: index,
      showModalCarousel: true
    });
    overflowContainer(true);
  };

  return {
    resizeHandler,
    handleResize,
    handleOpenContactModal,
    hideModal,
    showModal,
    openModalPostLead,
    handleCloseContactModal,
    handleBoatSummaryScroll,
    handleSummaryLocationLinkClicked,
    handleSummaryLoansButtonclicked,
    handleSummaryPaymentLinkClicked,
    toggleVideoTourModal,
    toggleDealerLocatorModal,
    showModalPreQualified,
    getCarouselButtonTrayProps,
    getButtonTrayProps,
    handleOpenContactForm,
    openImmersiveTourModal,
    openCarousel
  };
};

export const getSecondAdParams = (showThirdAdbox, adReload, adParams) => {
  const secondAdBoxParams = { ...adParams.sideBarAd2Params };
  if (showThirdAdbox) {
    secondAdBoxParams.reloadAd = adReload;
    secondAdBoxParams.targeting = { refresh: adReload.toString() };
  }

  return secondAdBoxParams;
};

export const createCarouselButtons = (
  mediaImages,
  mediaVideos,
  showModalCarousel
) => {
  const { messages, t } = syncTranslationElements();
  const buttons = [
    {
      title: `${t(messages.viewCarouselPhotos.view)} ${mediaImages.length} ${
        mediaImages.length > 1 ? t(messages.viewCarouselPhotos.photos) : t(messages.viewCarouselPhotos.photo)
      }`,
      onClick: () => showModalCarousel(0),
      show: mediaImages.length > 0
    },
    {
      title: `${t(messages.viewCarouselVideos.video)}`,
      onClick: () => {
        showModalCarousel(mediaImages.length > 0 ? 1 : 0);
      },
      show: mediaVideos.length > 0
    }
  ];
  return buttons;
};
